import { artistPresetsInitialState } from './initial-state';
import { ArtistPresetsActions } from './action-creators';
import { ArtistPresetsState } from './state';
import * as actions from './actions';

export const artistPresetsReducer = (
  state: ArtistPresetsState = artistPresetsInitialState,
  action: ArtistPresetsActions
): ArtistPresetsState => {
  switch (action.type) {
    case actions.GET_ARTIST_PRESETS:
      return {
        ...state,
        presets: undefined,
      };

    case actions.GET_ARTIST_PRESETS_SUCCESS:
      return {
        ...state,
        presets: action.presets,
      };

    case actions.UPDATE_ARTIST_PRESETS_FIELD:
      return {
        ...state,
        presets: {
          ...state.presets,
          [action.field]: action.value,
        },
      };

    default:
      return state;
  }
};

export default artistPresetsReducer;
